import { render, staticRenderFns } from "./Risks.vue?vue&type=template&id=5cf84dfd&scoped=true"
import script from "./Risks.vue?vue&type=script&lang=js"
export * from "./Risks.vue?vue&type=script&lang=js"
import style0 from "./Risks.vue?vue&type=style&index=0&id=5cf84dfd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf84dfd",
  null
  
)

export default component.exports